'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DialogWrap = require('./DialogWrap');

var _DialogWrap2 = _interopRequireDefault(_DialogWrap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _DialogWrap2['default']; // based on vc-dialog 7.5.14